function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  height: 24,
  width: 24
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  height: 24,
  width: 24
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 4.81,
  cy: 3.89,
  r: 2.01
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.45,10.75a.69.69,0,0,0,.5-.21L12.51,8a.7.7,0,0,0,.11-.91A.69.69,0,0,0,11.55,7L9.46,9S8.52,8.2,7.57,7.25A2.23,2.23,0,0,0,6,6.48H3.35A1.44,1.44,0,0,0,2,7.89v4.26a.62.62,0,0,0,.62.62h4a.62.62,0,0,0,.62-.62V8.94l1.68,1.6A.9.9,0,0,0,9.45,10.75Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.76,2.39V7a.47.47,0,0,0,.12.32l.18.18a.45.45,0,0,0,.66,0h0a.45.45,0,0,0,.14-.33V3.65a.46.46,0,0,1,.46-.47H20.44a.47.47,0,0,1,.46.47V11.2a.47.47,0,0,1-.46.47H9.22a.46.46,0,0,0-.46.46v.17a.46.46,0,0,0,.46.47H21.54A.47.47,0,0,0,22,12.3V2.39a.46.46,0,0,0-.46-.46H9.22A.45.45,0,0,0,8.76,2.39Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.11,18.35a1.72,1.72,0,1,1,1.72-1.71,1.72,1.72,0,0,1-1.72,1.71"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2,21.49v-.73a2,2,0,0,1,2-2H6.13A2.07,2.07,0,0,1,8.2,20.85v.64a.63.63,0,0,1-.63.63H2.62A.63.63,0,0,1,2,21.49Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.92,18.35a1.72,1.72,0,1,1,1.71-1.71,1.72,1.72,0,0,1-1.71,1.71"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.8,21.49v-.73a2,2,0,0,1,2-2h2.15A2.07,2.07,0,0,1,22,20.85v.64a.63.63,0,0,1-.62.63H16.43A.63.63,0,0,1,15.8,21.49Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,18.35a1.72,1.72,0,1,1,1.71-1.71A1.72,1.72,0,0,1,12,18.35"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.9,21.49v-.73a2,2,0,0,1,2-2H13a2.07,2.07,0,0,1,2.07,2.07v.64a.63.63,0,0,1-.62.63h-5A.63.63,0,0,1,8.9,21.49Z"
})));

var SvgInstructions = function SvgInstructions(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstructions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instructions.9b319854.svg";
export { ForwardRef as ReactComponent };